export const LABELS = {
  ACTIONS: {
    NAVIGATE_TO_ORDER: ['pages.pwcOrders.list.components.actions.navigateToOrder', 'Open Order Details'],
    COPY_ORDER_ID: ['pages.pwcOrders.list.components.actions.copyOrderId', 'Copy Order ID'],
    COPY_CUSTOMER_EMAIL: ['pages.pwcOrders.list.components.actions.copyCustomerEmail', 'Copy Customer E-mail'],
  },
};
